import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arw-head-s",
  "use": "arw-head-s-usage",
  "viewBox": "0 237.4 595.279 367.089",
  "content": "<symbol viewBox=\"0 237.4 595.279 367.089\" id=\"arw-head-s\"><path d=\"M69.449 237.4L0 306.85l297.64 297.64 297.64-297.64-69.45-69.45-228.19 228.191L69.449 237.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/arw-head-s.svg
// module id = 143
// module chunks = 0